import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import SmoothScroll from "@/components/SmoothScroll";
import Landing from "@/pages/Landing";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import LegalPage from "@/pages/LegalPage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import Orders from "@/pages/admin/Orders";
import OrderDetail from "@/pages/admin/OrderDetail";
import Payments from "@/pages/admin/Payments";
import Verifications from "@/pages/admin/Verifications";
import Products from "@/pages/admin/Products";
import AdminReviews from "@/pages/admin/AdminReviews";
import AdminOutlets from "@/pages/admin/AdminOutlets";
import Invoices from "@/pages/admin/Invoices";
import Messages from "@/pages/admin/Messages";
import Customers from "@/pages/admin/Customers";
import AuditLog from "@/pages/admin/AuditLog";
import Users from "@/pages/admin/Users";
import Settings from "@/pages/admin/Settings";
import Insights from "@/pages/admin/Insights";
import StripeEvents from "@/pages/admin/StripeEvents";
import Subscriptions from "@/pages/admin/Subscriptions";
import DeployStatus from "@/pages/admin/DeployStatus";

function ProtectedRoute({ children }) {
  const { user, checking } = useAuth();
  if (checking) return <div className="flex min-h-screen items-center justify-center bg-sfc-night text-white/60">Laden...</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <SmoothScroll />
        <Toaster position="top-center" richColors theme="dark" />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/betaling/succes" element={<PaymentSuccess />} />
          <Route path="/betaling/geannuleerd" element={<PaymentCancel />} />
          <Route path="/voorwaarden" element={<LegalPage pageKey="terms" title="Algemene voorwaarden" />} />
          <Route path="/privacy" element={<LegalPage pageKey="privacy" title="Privacybeleid" />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
            <Route index element={<Dashboard />} />
            <Route path="orders" element={<Orders />} />
            <Route path="orders/:id" element={<OrderDetail />} />
            <Route path="payments" element={<Payments />} />
            <Route path="verificaties" element={<Verifications />} />
            <Route path="insights" element={<Insights />} />
            <Route path="stripe-events" element={<StripeEvents />} />
            <Route path="abonnementen" element={<Subscriptions />} />
            <Route path="deploy" element={<DeployStatus />} />
            <Route path="producten" element={<Products />} />
            <Route path="reviews" element={<AdminReviews />} />
            <Route path="verkooppunten" element={<AdminOutlets />} />
            <Route path="facturen" element={<Invoices />} />
            <Route path="berichten" element={<Messages />} />
            <Route path="klanten" element={<Customers />} />
            <Route path="auditlog" element={<AuditLog />} />
            <Route path="gebruikers" element={<Users />} />
            <Route path="instellingen" element={<Settings />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
